import { Component, Host, Prop, h, Watch } from '@stencil/core';

@Component({
  tag: 'image-block',
  styleUrl: 'image-block.css',
  shadow: false,
})
export class ImageBlock {
  @Prop() imageUrl: string;
  @Prop() imageAlt: string;
  @Prop() imageClass: string;
  @Prop() imageWidth: number;
  @Prop() imageHeight: number;

  // Watcher for imageUrl changes (values are used for testing only)
  @Watch('imageUrl')
  imageUrlChanged(_newValue: string, _oldValue: string) {

  }

  render() {
    //console.log(`image-block.tsx: imageUrl: ${this.imageUrl}, imageAlt: ${this.imageAlt}, imageClass: ${this.imageClass}`);
    return (
      <Host>
        {this.imageUrl && (
          <img class={`max-h-full max-w-full overflow-hidden ${this.imageClass}`} src={this.imageUrl} alt={this.imageAlt} width={this.imageWidth} height={this.imageHeight} loading="lazy" />
        )}
      </Host>
    );
  }

}
